const playbackType = (entitlementType?: string) => {
  switch (entitlementType && entitlementType.toUpperCase()) {
    case 'RENTAL':
      return 'vod'
    case 'PURCHASE':
      return 'est'
    case 'AD_SUPPORTED':
      return 'ad'
    case 'PRIME_SUBSCRIPTION':
      return 'prime'
    case 'THIRD_PARTY_SUBSCRIPTION':
      return '3p'
    case 'FREE':
      return 'free'
    default:
      return ''
  }
}

const movieOrTv = (contentType?: string) => {
  switch (contentType && contentType.toUpperCase()) {
    case 'MOVIE':
      return 'movie'
    default:
      return 'tv'
  }
}

export const getPlaybackClickstreamRef = (
  contentType?: string,
  entitlementType?: string
) => {
  const type = playbackType(entitlementType)
  const familyType = movieOrTv(contentType)

  // TODO(AVWebDetailPage-1471) Use reftag generation tool
  return `atv_dp_stream_${type}_${familyType}`
}
